export type StoredLocationData = {
  latitude: number;
  longitude: number;
  city: string;
  state: string;
  country: string;
  createdAt: Date;
};

export const utmParamNames = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"] as const;
export const trackingParamNames = [...utmParamNames, "marketingId", "fbclid", "gclid", "referrer"] as const;

export type TrackingParams = {
  [key in (typeof trackingParamNames)[number]]?: string;
} & { utmQueryString?: string; sourceName?: string; sourcePhoneNumber?: string };

export type GetTrackingParamsResponse = {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
  marketingId?: string;
  facebookCLID?: string;
  googleCLID?: string;
  utmQueryString?: string;
  sourceName?: string;
  sourcePhoneNumber?: string;
  referrer?: string;
};
